const RESOLVERS = {
    MODULE_VEHICLE_WORK_ORDER: {
        labelKey: 'common.transaction.sourceModules.MODULE_VEHICLE_WORK_ORDER',
        getRoute: (id) => `/module/vehicle-work-order/save/${id}`,
    },
    COMPANY_CUSTOMER: {
        labelKey: 'common.transaction.sourceModules.COMPANY_CUSTOMER',
        getRoute: (id) => `/customer/detail/${id}`,
    },
}

export function resolveSourceLabelKey(sourceType) {
    return RESOLVERS[sourceType]?.labelKey || null
}

export function resolveSourceRoute(sourceType, sourceId) {
    const r = RESOLVERS[sourceType]
    if (!r || typeof r.getRoute !== 'function') return null
    return r.getRoute(sourceId)
}

export function registerSourceResolver(sourceType, config) {
    RESOLVERS[sourceType] = config
}

export default {
    resolveSourceLabelKey,
    resolveSourceRoute,
    registerSourceResolver,
}
